// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.displayTable{
  align-items: center;
  align-self: stretch;
}
.displayTable .table{
  overflow: scroll !important;
}
.displaytable .table-header {
    position: 'sticky';
    top: '0px';
}

.displaytable .table-header-cell {
  color: var(--theme-text-primary) !important;
  font-family: Open Sans variable, Helvetica !important;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  align-self: 'center';
}`, "",{"version":3,"sources":["webpack://./src/components/OverviewTable/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;EACE,2CAA2C;EAC3C,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".displayTable{\n  align-items: center;\n  align-self: stretch;\n}\n.displayTable .table{\n  overflow: scroll !important;\n}\n.displaytable .table-header {\n    position: 'sticky';\n    top: '0px';\n}\n\n.displaytable .table-header-cell {\n  color: var(--theme-text-primary) !important;\n  font-family: Open Sans variable, Helvetica !important;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n  width: fit-content;\n  align-self: 'center';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
